<app-main-contents>
  <!-- パンくず -->
  <app-breadcrumbs [label2]="title"></app-breadcrumbs>

  <!-- タイトル -->
  <app-title [title]="title"></app-title>

  <!-- 申込み確定後の完了メッセージ -->
  <div *ngIf="isConfirmed" class="h-margin--t16">
    <p>お申込みいただきありがとうございました。</p>
    <p>受付完了のメールをお送りしておりますので、ご確認ください。</p>
    <p>※メールが到着するまで、お時間をいただく場合がございます。</p>
    <p class="h-margin--t16">トップに戻るまで {{ countdown }} 秒</p>
  </div>

  <ng-container *ngIf="!isConfirmed">
    <!-- TODO: 本文レイアウトは今後の要件に応じて実装 -->
    <!-- 見積もりロード中スケルトン -->
    <div class="c-iframe h-margin--t16" *ngIf="!isShowTerms && loadingEstimate">
      <div class="c-skeleton">
        <!-- ヘッダー部分 -->
        <div class="c-skeleton__header">
          <div class="c-skeleton__title"></div>
          <div class="c-skeleton__number"></div>
        </div>
        <!-- 送信者・受信者情報部分 -->
        <div class="c-skeleton__info">
          <div class="c-skeleton__recipient">
            <div class="c-skeleton__bar c-skeleton__bar--medium"></div>
            <div class="c-skeleton__bar c-skeleton__bar--small"></div>
          </div>
          <div class="c-skeleton__sender">
            <div class="c-skeleton__logo"></div>
            <div class="c-skeleton__bar c-skeleton__bar--small"></div>
            <div class="c-skeleton__bar c-skeleton__bar--small"></div>
          </div>
        </div>
        <!-- 合計金額ボックス -->
        <div class="c-skeleton__total-box">
          <div class="c-skeleton__bar c-skeleton__bar--medium"></div>
          <div class="c-skeleton__amount"></div>
        </div>
        <!-- テーブルヘッダー -->
        <div class="c-skeleton__table-header">
          <div class="c-skeleton__table-cell"></div>
          <div class="c-skeleton__table-cell"></div>
          <div class="c-skeleton__table-cell"></div>
          <div class="c-skeleton__table-cell"></div>
          <div class="c-skeleton__table-cell"></div>
          <div class="c-skeleton__table-cell"></div>
          <div class="c-skeleton__table-cell"></div>
        </div>
        <!-- テーブル行（複数行） -->
        <div class="c-skeleton__table-row" *ngFor="let i of [1, 2, 3, 4]">
          <div class="c-skeleton__table-cell"></div>
          <div class="c-skeleton__table-cell"></div>
          <div class="c-skeleton__table-cell"></div>
          <div class="c-skeleton__table-cell"></div>
          <div class="c-skeleton__table-cell"></div>
          <div class="c-skeleton__table-cell"></div>
          <div class="c-skeleton__table-cell"></div>
        </div>
      </div>
    </div>
    <!-- isShowTerms が false の場合：申込みのサービス明細を iframe で表示 -->
    <div class="c-iframe h-margin--t16" *ngIf="!isShowTerms && !loadingEstimate">
      <div class="c-iframe__tabs" *ngIf="estimateUrls.length > 1">
        <button
          *ngFor="let url of estimateUrls; let i = index"
          class="c-iframe__tab"
          [class.c-iframe__tab--active]="activeEstimateIndex === i"
          (click)="selectEstimate(i)"
        >
          御見積書 {{ i + 1 }}
        </button>
      </div>
      <iframe [src]="estimateUrl"> </iframe>
    </div>

    <!-- isShowTerms が true の場合：利用規約を iframe で表示 -->
    <div class="c-pdf h-margin--t16" *ngIf="isShowTerms">
      <iframe [src]="riyoukiyakuUrl"> </iframe>
    </div>

    <!-- 利用規約同意チェック：service-policy コンポーネントと同様の見た目に揃える -->
    <div
      *ngIf="isShowTerms"
      #consentSection
      class="c-policy h-margin--t16"
      [ngClass]="{ 'consent-highlight': isConsentHighlightActive }"
    >
      <p class="c-policy__title">利用規約の確認と同意</p>
      <p class="c-policy__note">「申込みを確定する」ボタンを押すには、以下の利用規約に同意してください。</p>
      <label class="c-form__checkbox2">
        <input type="checkbox" (change)="onChangeTermsAgreed($event.target.checked)" />
        <span>利用規約に同意する</span>
      </label>
    </div>
  </ng-container>

  <!-- フッター固定ボタン -->
  <app-under-btn-disp [actionButtons]="actionButtons"></app-under-btn-disp>
</app-main-contents>

<app-confirm-dialog
  *ngIf="confirmDialogOpen"
  title="申込み確認"
  message="申込みを確定します。よろしいですか？"
  commitButtonText="確定する"
  cancelButtonText="キャンセル"
  (commit)="onConfirmApproval()"
  (cancel)="confirmDialogOpen = false"
>
</app-confirm-dialog>
